<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Laudos de Higienização</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Novo Laudo"
          icon="assets/add.svg"
          (click)="navegarNovoLaudo()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Listagem</div>
        <div class="align-button">
          <form [formGroup]="form">
            <div class="table-filters">
              <app-input
                label="ID Empresa"
                placeholder="Digite aqui"
                name="FK_EPSA"
                formControlName="FK_EPSA"
                class="small-input"></app-input>
              <app-input
                label="Placa do Cavalo"
                placeholder="Digite aqui"
                name="TX_PLCA_CRRT"
                formControlName="TX_PLCA_CRRT"
                class="small-input"></app-input>
              <app-input
                type="datetime-local"
                label="Data Início Serviço"
                placeholder="Digite aqui"
                name="DT_GATE_ENTR_INIC"
                formControlName="DT_GATE_ENTR_INIC"
                width="100%"></app-input>
              <app-input
                type="datetime-local"
                label="Data Fim Serviço"
                placeholder="Digite aqui"
                name="DT_GATE_ENTR_FIM"
                formControlName="DT_GATE_ENTR_FIM"
                width="100%"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>

  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="ID Empresa/Motorista"
        placeholder="Digite aqui"
        name="FK_EPSA"
        formControlName="FK_EPSA"
        width="100%"></app-input>
      <app-input
        label="Placa do Cavalo"
        placeholder="Digite aqui"
        name="TX_PLCA_CRRT"
        formControlName="TX_PLCA_CRRT"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Início Serviço"
        placeholder="Digite aqui"
        name="DT_GATE_ENTR_INIC"
        formControlName="DT_GATE_ENTR_INIC"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Fim Serviço"
        placeholder="Digite aqui"
        name="DT_GATE_ENTR_FIM"
        formControlName="DT_GATE_ENTR_FIM"
        width="100%"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <div class="paginacao">
    <app-paginacao
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>

  <div class="modal-overlay" *ngIf="showModal" (click)="fecharModalLaudo()">
    <div class="pdf" (click)="$event.stopPropagation()">
      <button type="button" class="pdf-close" (click)="fecharModalLaudo()" aria-label="Fechar">
        ×
      </button>
      <pdf-viewer
        *ngIf="pdfBase64"
        [src]="pdfBase64"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="false"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        [stick-to-page]="false"
        [render-text]="true"
        [external-link-target]="'blank'"
        [autoresize]="true"
        [show-borders]="false" />
    </div>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
